<template>
  <div class="box">
    <gallery
      :images="images"
      :index="imgIndex"
      @close="imgIndex = null"
    ></gallery>
    <div class="content">
      <div class="arrow-button" @click="goBack()">返回</div>

      <!-- 可滚动内容区域 -->
      <div
        class="scrollable-content"
        :class="{ 'has-reply-box': info.status == 0 }"
      >
        <!-- 循环展示所有对话组 -->
        <div
          v-for="(conversation, groupIndex) in conversationsList"
          :key="groupIndex"
          class="conversation-group"
        >
          <!-- 历史详情标题（除了第一组） -->
          <div v-if="groupIndex > 0" class="history-title">历史详情</div>

          <!-- 详情标题（第一组） -->
          <div v-else class="detail-title">详情</div>

          <!-- 用户消息 -->
          <div v-if="conversation.userMessage">
            <div class="title">{{ info.title }}</div>
            <div class="title_info">
              <div class="title_name">{{ info.userName }}</div>
              <div class="title_time">
                {{ rebuildTime(conversation.userMessage.sendTime) }}
              </div>
            </div>
            <div class="title_info">
              <div class="title_name">
                IP: {{ conversation.userMessage.ip }}
              </div>
              <div class="title_time">
                IP归属地: {{ conversation.userMessage.ipRegion }}
              </div>
            </div>
            <div class="text_content">
              <p>{{ conversation.userMessage.messageContent }}</p>
              <div
                class="imgList"
                v-if="
                  conversation.userMessage.attachments &&
                    conversation.userMessage.attachments.length > 0
                "
              >
                <div
                  v-for="(item, index) in conversation.userMessage.attachments"
                  @click="openImage(groupIndex, index)"
                  :key="index"
                >
                  <img v-if="item.fileType == 0" :src="item.fileUrl" />
                  <img v-else :src="item.firstFrameImageUrl" />
                </div>
              </div>
            </div>
          </div>

          <!-- 客服回复 -->
          <div v-if="conversation.replyMessage" class="reply_content">
            <div class="gang">
              <div class="line-left"></div>
              <div class="text">回复内容</div>
              <div class="line-right"></div>
            </div>
            <div class="flex_info">
              <img src="../../assets/userHeader.png" />
              <div class="">
                <p class="name">担当官方</p>
                <span class="userid">{{
                  rebuildTime(conversation.replyMessage.sendTime)
                }}</span>
              </div>
            </div>
            <div class="text_content">
              <p>{{ conversation.replyMessage.messageContent }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 回复输入框 - 固定在底部 -->
      <div class="reply_box" v-if="info.status == 0">
        <textarea
          class="inp"
          v-model="replyText"
          :disabled="isSubmitting"
        ></textarea>
        <button
          @click="replyFn()"
          :disabled="isSubmitting"
          :class="{ 'is-submitting': isSubmitting }"
        >
          {{ isSubmitting ? "发送中..." : "发送" }}
        </button>
      </div>
    </div>
    <div class="info">
      <div class="title">用户信息</div>
      <div class="info_box">
        <div class="flex_info">
          <img :src="info.userAvatar" />
          <div class="">
            <p class="name">
              {{ info.userName }}
              <img
                style="width: 22px; height: 22px; margin-left: 4px; vertical-align: middle;"
                :src="
                  info.kycStatus == 0
                    ? require('@/assets/icon/Unverified.png')
                    : require('@/assets/icon/realname.png')
                "
                :alt="info.kycStatus == 0 ? '未实名' : '已实名'"
              />
            </p>
            <span class="userid">ID:{{ info.userId }}</span>
          </div>
        </div>
        <div class="flex_info_item">
          <div class="flex_info_item_title">用户名:</div>
          <div class="flex_info_item_content">{{ info.userName }}</div>
        </div>
        <div class="flex_info_item">
          <div class="flex_info_item_title">手机号:</div>
          <div class="flex_info_item_content">{{ info.mobile }}</div>
        </div>
        <div class="flex_info_item">
          <div class="flex_info_item_title">所属公司:</div>
          <div class="flex_info_item_content">{{ info.companyName }}</div>
        </div>
        <div class="flex_info_item">
          <div class="flex_info_item_title">机型:</div>
          <div class="flex_info_item_content">{{ info.device }}</div>
        </div>
        <div class="flex_info_item">
          <div class="flex_info_item_title">当前版本:</div>
          <div class="flex_info_item_content">{{ info.appVersion }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";
import { getFeedBackDetail, replyFeedBack } from "@/api/index";

export default {
  components: {
    gallery: VueGallery,
  },
  data() {
    return {
      id: "",
      info: {},
      replyText: "",
      images: [],
      imgIndex: null,
      conversationsList: [],
      isSubmitting: false,
    };
  },
  mounted(query) {
    this.id = this.$route.query.id;
    this.getData();
  },
  methods: {
    getData() {
      getFeedBackDetail(this.id).then((res) => {
        this.info = res.data;
        console.log(this.info);

        // 处理所有对话组
        if (
          res.data.conversationsGroup &&
          res.data.conversationsGroup.length > 0
        ) {
          this.conversationsList = res.data.conversationsGroup.map((group) => {
            const userMessage = group.find((item) => item.senderType == 0);
            const replyMessage = group.find((item) => item.senderType == 1);
            return {
              userMessage,
              replyMessage,
            };
          });

          // 处理所有图片和视频附件用于画廊
          this.images = [];
          res.data.conversationsGroup.forEach((group) => {
            const userMsg = group.find((item) => item.senderType == 0);
            if (userMsg && userMsg.attachments) {
              userMsg.attachments.forEach((item) => {
                if (item.fileType == 0) {
                  this.images.push({
                    title: "Fruits",
                    type: "image/jpeg",
                    href: item.fileUrl,
                    poster: item.fileUrl,
                  });
                } else if (item.fileType == 1) {
                  this.images.push({
                    title: "Fruits",
                    type: "video/mp4",
                    href: item.fileUrl,
                    poster: item.firstFrameImageUrl,
                  });
                }
              });
            }
          });
        }
      });
    },
    openImage(groupIndex, attachmentIndex) {
      // 计算全局图片索引
      let globalIndex = 0;
      for (let i = 0; i < groupIndex; i++) {
        if (
          this.conversationsList[i].userMessage &&
          this.conversationsList[i].userMessage.attachments
        ) {
          globalIndex += this.conversationsList[i].userMessage.attachments
            .length;
        }
      }
      globalIndex += attachmentIndex;
      this.imgIndex = globalIndex;
    },
    replyFn() {
      // 防抖：如果正在提交，直接返回
      if (this.isSubmitting) {
        return;
      }

      console.log(this.replyText);
      if (!this.replyText) {
        this.$message({
          type: "info",
          message: "填写信息后重新发发送",
        });
        return;
      }

      // 设置提交状态
      this.isSubmitting = true;

      let data = {
        feedbackId: this.id,
        userId: this.info.userId,
        replyContent: this.replyText,
      };
      replyFeedBack(data)
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "发送成功",
            });
            this.replyText = "";
            this.getData();
          }
        })
        .finally(() => {
          // 无论成功或失败，都重置提交状态
          this.isSubmitting = false;
        });
    },
    rebuildTime(time, type) {
      const now = new Date().getTime();
      const date = new Date(Number(time)),
        Y = date.getFullYear(),
        M =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1,
        D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(),
        h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        m =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      const dateTimestamp = date.getTime();
      if (type == 2) {
        return String(Y).concat("/", M, "/", D);
      } else {
        return String(Y).concat("/", M, "/", D, " ", h, ":", m);
      }
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  padding-bottom: 16px;
}

.arrow-button {
  position: relative;
  width: 60px;
  height: 20px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding-left: 10px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-shrink: 0;
}

.arrow-button::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0%;
  width: 10px;
  height: 10px;
  border-left: 2px solid #000;
  border-top: 2px solid #000;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.title {
  color: #1d2129;
  font-size: 16px;
  font-weight: 500;
}

.content {
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 122px);
  overflow: hidden;
}

.scrollable-content {
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;

  &.has-reply-box {
    margin-bottom: 140px;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.title_info {
  display: flex;
  margin-top: 4px;
  color: rgba($color: #000000, $alpha: 0.6);

  .title_name {
    padding-right: 8px;
  }

  .title_time {
    padding-left: 8px;
    border-left: 1px solid #ebebeb;
  }
}

.text_content {
  color: rgba($color: #000000, $alpha: 0.6);
  margin-top: 8px;
}

.imgList {
  display: flex;
  margin-top: 16px;

  img {
    width: 80px;
    height: 80px;
    border-radius: 6px;
    margin-right: 10px;
  }
}

.reply_box {
  position: absolute;
  left: 16px;
  bottom: 16px;
  width: calc(100% - 32px);
  height: 120px;
  background: #f6f7fb;
  padding: 10px;
  border-radius: 8px;

  .inp {
    resize: none;
    width: calc(100% - 20px);
    height: 80px;
  }

  button {
    width: 80px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #2c67ec;
    color: #fff;
    position: absolute;
    bottom: 6px;
    right: 6px;
    border-radius: 6px;
    cursor: pointer;
    border: none;
    transition: all 0.3s;

    &:hover:not(:disabled) {
      background: #4d7ef7;
    }

    &:disabled,
    &.is-submitting {
      background: #a0cfff;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
}

.reply_content {
  margin-top: 30px;
}

.conversation-group {
  margin-bottom: 20px;
  padding: 16px;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  background-color: #fafafa50;

  &:last-child {
    margin-bottom: 0;
  }
}

.detail-title {
  color: #1d2129;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
}

.history-title {
  color: #1d2129;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
  margin-top: 20px;
}

.gang {
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  .text {
    color: rgba(0, 0, 0, 0.6);
    margin: 0 24px;
  }

  .line-left {
    flex: 1;
    height: 1px;
    background: linear-gradient(
      90deg,
      rgba(235, 235, 235, 0) 0%,
      rgb(235, 235, 235) 100%
    );
  }

  .line-right {
    flex: 1;
    height: 1px;
    background: linear-gradient(
      90deg,
      rgb(235, 235, 235) 0%,
      rgba(235, 235, 235, 0) 100%
    );
  }
}

// 用户信息
.info {
  width: 239px;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-left: 12px;
}

.info_box {
  background-color: #f6f7fb;
  border-radius: 8px;
  padding: 8px;
  margin-top: 12px;
}

.flex_info {
  display: flex;
  align-items: center;

  img {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    margin-right: 8px;
  }

  .name {
    color: #1d2129;
    font-size: 16px;
    font-weight: 500;
  }

  .userid {
    color: rgba($color: #000000, $alpha: 0.6);
    font-size: 12px;
  }
}

.flex_info_item {
  width: 250px;
  display: flex;
  margin-top: 8px;

  .flex_info_item_title {
    width: 60px;
    font-size: 14px;
    color: rgba($color: #000000, $alpha: 0.6);
    line-height: 20px;
  }

  .flex_info_item_content {
    line-height: 20px;
    width: 120px;
    margin-left: 6px;
    color: rgba($color: #000000, $alpha: 0.9);
    word-wrap: break-word;
    /* 或者使用 overflow-wrap: break-word; */
    white-space: normal;
    /* 确保文字可以换行 */
    box-sizing: border-box;
    /* 确保内边距和边框包含在宽度内 */
  }
}
</style>
